import HttpRequest from "@/services/http_request";

class PreEnrollProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_API_ENDPOINT);
  }

  async getPreEnroll(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/enroll/preenroll");
    const { data } = res.data;
    // const data = [
    //   {
    //     COURSECODE: "1803330",
    //     COURSENAME: "Exercise for Noncommunicable Diseases Prevention",
    //     COURSEUNIT: "3 (3-0-6)",
    //     GRADEMODE_TEXT: "A-F",
    //     CLASSTIME: "WE 17:00 - 19:50",
    //     SECTION_TEXT: " 01",
    //     CLASSSTATUS: "W",
    //     CONFIRM_FLAG: "ยืนยัน",
    //     REASON: "รายวิชาที่ได้รับสำรองสิทธิ์"
    //   }
    // ];
    return data;
  }

  async postPreEnroll(token, payload) {
    this.setHeaderBearerAuth(token);
    const { data } = await this.create("reg/enroll/preenroll", payload);
    return data;
  }

  async putPreEnroll(token, payload) {
    this.setHeaderBearerAuth(token);
    const { data } = await this.update("/reg/enroll/preenroll", payload);
    return data;
  }

  async deletePreEnroll(token, payload) {
    this.setHeaderBearerAuth(token);
    const { data } = await this.delete("reg/enroll/preenroll", {}, payload);
    return data;
  }

  async confirmPreEnroll(token, payload) {
    this.setHeaderBearerAuth(token);
    const { data } = await this.create("reg/enroll/preenrollconfirm", payload);
    return data;
  }

  async getPreEnrollTotal(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester)
    });
    const res = await this.get("reg/enroll/preenroll/total");
    const { data } = res.data;
    return data;
  }

  async getApproveresult(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/enroll/preenroll/approveresult");
    const { data } = res.data;
    return data;
  }

  async changeSection(token, payload) {
    this.setHeaderBearerAuth(token);
    const { data } = await this.create(
      "reg/enroll/preenrollchangesection",
      payload
    );
    return data;
  }

  async preEnrollWithInstructor(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/enroll/preenrollwithinstructor");
    return res.data;
  }
}

export default PreEnrollProvider;
